import React, { useState } from "react";
import styled from "./Settings.module.scss";
import styledMain from "./PlayerMain.module.scss";
import { LANGUAGES } from "@/shared/const/locale";
import { VIDEO_QUALITY } from "@/features/player/const";
import { QualityType } from "@/features/player/model/types";

interface SettingsPopupProps {
    selectLang: string;
    setSelectLang: (val: string) => void;
    speed: number;
    setSpeed: (val: number) => void;
    setQuality: (val: QualityType) => void;
}

export const SettingsPopup: React.FC<SettingsPopupProps> = ({
    selectLang,
    setSelectLang,
    speed,
    setSpeed,
    setQuality,
}) => {
    const [lang, setLang] = useState(() => selectLang);
    const [qualityVal, setQualityVal] = useState(() => QualityType.q1080);
    const [speedValue, setSpeedValue] = useState(() => speed);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const val = e.target.value;
        setSelectLang(val);
        setLang(val);
    };

    const handleChangeQuality = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const val = e.target.value;
        setQualityVal(val as QualityType);
        setQuality(val as QualityType);
    };

    const handleChangeSpeed = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = parseFloat(e.target.value);
        setSpeed(val);
        setSpeedValue(val);
    };

    return (
        <div className={styled.settingsContainer}>
            <div className={styled.settingsRow}>
                <div className={styled.settingsTitle}>Audio language</div>
                <select
                    value={lang}
                    onChange={handleChange}
                    style={{ fontSize: "1rem" }}
                >
                    {Object.entries(LANGUAGES).map(
                        ([code, { label, flag }]) => (
                            <option key={code} value={code}>
                                {label}
                            </option>
                        ),
                    )}
                </select>
            </div>
            <div className={styled.settingsRow}>
                <div className={styled.settingsTitle}>Quality</div>
                <select
                    value={qualityVal}
                    onChange={handleChangeQuality}
                    style={{ fontSize: "1rem" }}
                >
                    {Object.entries(VIDEO_QUALITY).map(
                        ([code, { label, value }]) => (
                            <option key={code} value={value}>
                                {label}
                            </option>
                        ),
                    )}
                </select>
            </div>
            <div className={styled.settingsRow}>
                <div className={styled.settingsTitle}>
                    Speed rate: {speedValue.toString()}
                </div>
                <input
                    type="range"
                    min="0.7"
                    max="1.2"
                    step="0.1"
                    value={speedValue.toString()}
                    onChange={handleChangeSpeed}
                    className={styledMain["range"]}
                    style={{
                        ["--percent" as any]: `${((speedValue - 0.7) / 0.5) * 100}%`,
                    }}
                />
            </div>
        </div>
    );
};
